import React from 'react';
import ButtonsGeneric from '../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';
import InputText from '../../../../../../../components/NovoSistema/InputText';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function SimulacaoDePreco() {
  return (
    <div>
      <ContainerSection>
        <WrapperInputsNewSystem>
          <DoubleInput title="MC Esperada" id="MCEsperada" widthPercentage="45%" />
          <InputText title="Valor Líquido Total" id="ValorLiquidoTotal" widthPercentage="45%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <DoubleInput title="Qtd de Parcelas" id="QtdDeParcelas" widthPercentage="45%" />
          <InputText title="Valor por Parcela Fixa" id="ValorPorParcelaFixa" disabled={true} widthPercentage="45%" />
        </WrapperInputsNewSystem>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error">Retornar</button>
      </ButtonsGeneric>
    </div>
  );
}
